import { Draft, PayloadAction } from "@reduxjs/toolkit"

export function SimpleSelector<T, K extends keyof T = keyof T>(key: K) {
	return (state: T): T[K] => state[key]
}

export const SimpleSetter = <S extends Record<string, any>, T extends S[keyof S]>(
	key: keyof S,
	debugFn: (state: Draft<S>, action: PayloadAction<T>) => void = Noop()
) => {
	return (state: Draft<S>, action: PayloadAction<T>) => {
		(state as S)[key] = action.payload
		debugFn(state, action)
	}
}

/**
 * Retrieves the value at a given nested path within an object.
 *
 * @param {Record<string, any>} obj - The object from which to retrieve the value.
 * @param {string} path - The path to the desired value, represented as a dot-separated string.
 * @returns {any} - The value at the specified path, or `undefined` if the path does not exist.
 */
export function GetNestedValue<T extends Record<string, any>>(obj: T, path: string): unknown {
	return path.Split(".").Fold(obj, (acc, part) => acc && acc[part])
}

export const Noop =
	<T>() =>
	(state: Draft<any>, _action: PayloadAction<T>) =>
		state
